import { css } from 'styled-components';

export const textSecurity = css`
	text-security: disc;
	-webkit-text-security: disc;
	-mox-text-security: disc;
`;
